















import Vue, { PropType } from "vue";
import ImageModel from "@/dex-shared/models/ImageModel";
import VueMarkdown from "vue-markdown";
export default Vue.extend({
  components: {
    VueMarkdown
  },
  props: {
    image: {
      type: Object as PropType<ImageModel>,
      required: true
    }
  }
});
